<template>
  <div v-show="!hideAll" style="height: 100%">
    <div class="background" :style="sectionBackgroundStyle">
      <div class="overlay"></div>
    </div>
    <div class="login d-flex flex-column justify-center align-center">
      <v-card
        v-if="!showCreate"
        class="
          d-flex
          flex-column
          justify-center
          align-center
          pa-10
          elevation-0
          card-radius
        "
        width="800px"
      >
        <img :src="logoUrl" style="width: 150px" />
        <p class="headline mt-4">Select an option below</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <a @click="showCreate = true">
                <v-card outlined hover class="text-center card-radius">
                  <v-icon size="60" class="mt-4">mdi-office-building</v-icon>
                  <v-card-title class="justify-center"
                    >Create Property</v-card-title
                  >
                  <v-card-subtitle>
                    Create your property with Spacepack and start your 60-day
                    FREE TRIAL today!
                  </v-card-subtitle>
                </v-card>
              </a>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <a @click="joinProperty">
                <v-card outlined hover class="text-center card-radius">
                  <v-icon size="60" class="mt-4">mdi-account-plus</v-icon>
                  <v-card-title class="justify-center"
                    >Join A Property</v-card-title
                  >
                  <v-card-subtitle>
                    Join an existing property and start managing it with
                    Spacepack.
                  </v-card-subtitle>
                </v-card>
              </a>
            </v-col>
          </v-row>
        </v-container>

        <div v-if="userProperties.length" style="width: 50%">
          <v-select
            v-model="selectedProperty"
            :items="userProperties"
            label="Return to Existing Property"
            hide-details
            append-inner-icon="mdi-home-city-outline"
            outlined
            dense
            @change="changeCurrentProperty"
          >
          </v-select>
        </div>
        <div v-if="propertyExists">
          <p class="caption text-center mt-2">Or</p>
          <a class="text-tiny text-center" @click="returnDashboard"
            >Return to Dashboard</a
          >
        </div>
        <div class="link"><a class="text-tiny" @click="logout">Log Out</a></div>
      </v-card>
      <v-card
        v-else-if="showCreate"
        class="d-flex flex-column justify-center align-center pa-12 card-radius"
        elevation="0"
      >
        <p class="headline text-center mb-4">New Property</p>
        <a id="logo-trigger">
          <v-avatar left color="grey" size="100" class="elevation-0">
            <img v-if="imageURL" :src="imageURL" />
            <v-icon v-else large dark>mdi-camera</v-icon>
          </v-avatar>
        </a>
        <p class="caption">Upload Logo</p>

        <v-form class="mt-10" @submit.prevent="createProperty">
          <v-text-field
            v-model="propertyName"
            name="Property Name"
            label="Property Name"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-text-field
            v-model="address1"
            name="address1"
            label="Address Line 1"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-text-field
            v-model="address2"
            name="address2"
            label="Address Line 2"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-text-field
            v-model="contactNumber1"
            name="contactNumber1"
            label="Property Contact Number"
            :rules="phMobileRules"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-text-field
            v-model="email1"
            name="email1"
            label="Property Email Address"
            :rules="emailRules"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-btn
            class="mt-5"
            block
            rounded
            depressed
            type="loginSubmit"
            :disabled="disabledButton"
            color="primary"
            >Submit Property</v-btn
          >
          <div class="link">
            <a class="text-tiny" @click="logout">Log Out</a>
          </div>
          <!-- <input type="email" placeholder="E-Mail" v-model="email">
          <input type="password" placeholder="Password" v-model="password"> -->
          <!-- <button type="submit">Login</button> -->
        </v-form>
        <avatar-cropper
          trigger="#logo-trigger"
          :upload-handler="logoUploadHandler"
          :labels="cropperLabels"
        />
      </v-card>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackMessage }}
      <v-btn color="primary" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper'

export default {
  components: {
    AvatarCropper
  },
  data() {
    return {
      propertyName: '',
      address1: '',
      address2: '',
      sectionBackgroundStyle: `background-image: url(${process.env.BASE_URL}images/cover_img_1.jpg); background-size:cover; background-position: center center;background-attachment:fixed;`,
      propertyExists: false,
      loading: true,
      showCreate: false,
      cropperLabels: {
        submit: 'Submit',
        cancel: 'Cancel'
      },
      imageBlob: null,
      contactNumber1: '',
      email1: '',
      snackMessage: '',
      timeout: 5000,
      snackbar: false,
      emailRules: [
        (v) => validateEmail(v) || 'E-Mail must be a valid e-mail format'
      ],
      phMobileRules: [
        (v) => {
          const pattern = /^(\+639)\d{9}$/
          return pattern.test(v) || 'Please use the format +63xxxxxxxxxx'
        }
      ],
      imageURL: '',
      joinPropertyDialog: false,
      hideAll: true,
      selectedProperty: null
    }
  },
  computed: {
    userProperties() {
      return this.$store.getters['auth/getUser'].property_details.map(
        (prop) => {
          return {
            value: prop.propertyId,
            text: prop.propertyName
          }
        }
      )
    },
    userType() {
      return this.$store.getters['auth/getUser'].userType
    },
    username() {
      return this.$store.getters['auth/getUser'].username
    },
    disabledButton() {
      return !(
        this.propertyName &&
        this.address1 &&
        this.contactNumber1 &&
        validateEmail(this.email1)
      )
    },
    logoUrl() {
      return `${process.env.BASE_URL}images/logo_text_bottom.png`
    }
  },
  async created() {
    if (this.userType === 'tenant') {
      this.$router.replace('/addEmergencyContact')
    }
    const property = await this.$store.dispatch(
      'properties/fetchPropertyAction'
    ) // remove this... maybe. or change this to a getter

    if (property) {
      // if(property.status !== 'rejected' && new Date(property.subscriptionStart) <= new Date() && new Date(property.subscriptionEnd) >= new Date()) {
      //   this.$router.replace('/dashboard')
      // }
      this.propertyExists = true
    }
    this.loading = false
    this.hideAll = false
  },
  methods: {
    async createProperty() {
      this.loading = true
      try {
        const property = await this.$store.dispatch(
          'properties/newPropertyAction',
          {
            propertyName: this.propertyName,
            address1: this.address1,
            address2: this.address2,
            email1: this.email1,
            contactNumber1: this.contactNumber1,
            logo: this.imageBlob
          }
        )

        if (!property) {
          throw new Error(
            'There was a problem creating your property. Please try again.'
          )
        }

        this.$router.replace('/dashboard')
      } catch (err) {
        this.snackMessage = err
        this.snackbar = true
        this.loading = false
      }
    },
    async logout() {
      await this.$store.dispatch('auth/doLogout')
      // this.$router.go()
      window.location.reload()
    },
    logoUploadHandler(cropper) {
      cropper.getCroppedCanvas().toBlob((blob) => {
        this.imageBlob = blob
        this.imageURL = URL.createObjectURL(blob)
        // this.$store.dispatch('properties/updatePropertyLogoAction', {logo: blob}).then(() => {
        //   this.$router.go()
        // })
      })
    },
    async joinProperty() {
      await this.$root.$confirm({
        title: 'Join Property',
        message: `The join property feature is still in progress! Please inform your property manager to add your username using the "Assign Page Role" in the My Property menu.`,
        reconfirmOnly: true,
        confirmText: 'Okay'
      })
    },
    returnDashboard() {
      this.$router.replace('/dashboard')
    },
    async changeCurrentProperty() {
      this.loading = true
      this.$store
        .dispatch('auth/changeCurrentPropertyAction', {
          propertyId: this.selectedProperty
        })
        .then(() => {
          this.loading = false
          this.$router.replace('/dashboard')
        })
        .catch((err) => {
          if (err == 'EXPIRED_PROPERTY') {
            this.$router.replace('/expired')
          }
          this.loading = false
        })
    }
  }
}

function validateEmail(email) {
  //eslint-disable-next-line
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
</script>

<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  height: 100%;
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #41129d 0%, #662d91 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #41129d),
    color-stop(100%, #662d91)
  );
  background: -webkit-linear-gradient(-45deg, #41129d 0%, #662d91 100%);
  background: -o-linear-gradient(-45deg, #41129d 0%, #662d91 100%);
  background: -ms-linear-gradient(-45deg, #41129d 0%, #662d91 100%);
  background: -webkit-linear-gradient(315deg, #41129d 0%, #662d91 100%);
  background: -o-linear-gradient(315deg, #41129d 0%, #662d91 100%);
  background: linear-gradient(135deg, #41129d 0%, #662d91 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#41129D', endColorstr='#662d91', GradientType=1 );
}
.login {
  /*background-image: `url(${process.env.BASE_URL}images/cover_img_1.jpg)`;*/
  height: 100%;
}
.v-card.card-radius {
  border-radius: 12px !important;
}
.v-form {
  width: 30vw;
}
.link {
  padding-top: 20px;
  text-align: center;
}
.link a {
  text-decoration: none;
  /*color: white;*/
  font-size: 20px;
}
.display-1 {
  letter-spacing: 0.5px;
  /*color: white;*/
}
.subtitle-2 {
  letter-spacing: 3px;
  /*color: white;*/
}
</style>
